import React, { Component } from 'react';
import { Table } from 'reactstrap';
import { Link, withRouter } from 'react-router-dom';
import './index.css';

//======================Custom checkbox======================
// PROPS
// name, checked State true or false, onChangeFunc to change check state and get data
const Checkbox = ({ type = 'checkbox', name, checked = false, onChange }) => (
    <div style={{ position: 'relative' }}>
        <input type={type} name={name} id={name} checked={checked} onChange={onChange} className="" />
    </div>
);

class TableNew extends Component {

    constructor(props) {
        super(props);
        this.state = {
            //Map() object for dynamic data filling and obtaining using get and set respectively.
            checkedItems: new Map(),

            checkedItemFull: [],
            sendCheckData: [],
            pageIndex: 0
        };

        this.mainCheckbox = React.createRef();

        this.handleChange = this.handleChange.bind(this);
    }

    componentDidUpdate(prevProps, prevState) {
        //reset items checked after props.data reset to new data
        if (prevProps.data !== this.props.data) {
            if (this.props.data === '') {
                if (this.props.data.length === 0) {
                    this.setState({
                        checkedItems: new Map()
                    })
                }
            }
        }


        //condition to check checkbox data checked true or false and send an array with data of checked rows to parent.
        if ((prevState.checkedItemFull !== this.state.checkedItemFull) || (prevProps.data !== this.props.data && this.props.data !== '')) {
            if (this.props.checkbox === "true") {
                if(prevProps.data !== this.props.data && this.props.data !== '') {
                    this.setState({
                        checkedItems: new Map(),
                        sendCheckData: [],
                    }, () => {
                        this.mainCheckbox.current.checked = false
                        this.props.getData(this.state.sendCheckData)
                    })
                }else {
                    let arrData = []
                    this.props.data.map(val => {
                        this.state.checkedItemFull.map(i => {
                            if ((val[this.props.CheckKey] === i[this.props.CheckKey]) && i.value === true) {
                                arrData.push(val)
                            }
                        })
                    })
    
                    this.setState({
                        sendCheckData: arrData
                    }, () => {
                        //Send data to parent after setState callback
                        this.props.getData(this.state.sendCheckData)
                    })
                }
            }
        }
    }

    //checkbox enable or disable function
    handleChange(e, data, type) {
        let that = this;

        //type will be single or all because of the usage of 1 function on all select box and single select box.
        if (type === 'single') {
            //=========================Add Checked True False to State=========================//
            //Current checkbox name
            const item = e.target.name;
            //True or false current State
            const isChecked = e.target.checked;
            //setting new state to prev state with name and status, eg: [{itemName: True}]
            this.setState(prevState => ({ checkedItems: prevState.checkedItems.set(item, isChecked) }), () => {
                //parsing map object to arrObj
                let arrChecked = []
                for (let e of this.state.checkedItems) {
                    arrChecked.push({
                        //CheckKey prop to select proper key.
                        [that.props.CheckKey]: e[0],
                        value: e[1]
                    })
                }
                let isAllChecked = true
                for (let i = 0; i < arrChecked.length; i++) {
                    const element = arrChecked[i];
                    if (element.value === false) {
                        isAllChecked = false
                        break;
                    }
                }
                if (isAllChecked === false) {
                    this.mainCheckbox.current.checked = false
                }
                //Use arrChecked which wll be put in checkedItemFull state object for sending data to parent        
                that.setState({
                    checkedItemFull: arrChecked
                })
            });
        } else if (type === 'all') {
            //Checked status
            const isChecked = e.target.checked
            //setting current Checked status to the whole checkedItems Map() Obj.
            
            // this.props.pagination ?
            //     this.props.data.filter(
            //         (_, i) => {
            //             return i >= (this.state.pageIndex * this.props.paginationAmount) && i < (this.state.pageIndex + 1) * this.props.paginationAmount
            //         }
            //     ).map(item => {
            //         that.setState(prevState => ({
            //             checkedItems: prevState.checkedItems.set(item[that.props.CheckKey], isChecked)
            //         }), () => {
            //             //Use arrChecked which wll be put in checkedItemFull state object for sending data to parent 
            //             let arrChecked = []
            //             for (let e of that.state.checkedItems) {
            //                 arrChecked.push({
            //                     //CheckKey prop to select proper key.
            //                     [that.props.CheckKey]: e[0],
            //                     value: e[1]
            //                 })
            //             }
            //             that.setState({
            //                 checkedItemFull: arrChecked
            //             })
            //         })
            //     })
            // :
                this.props.data.map(item => {
                    that.setState(prevState => ({
                        checkedItems: prevState.checkedItems.set(item[that.props.CheckKey], isChecked)
                    }), () => {
                        //Use arrChecked which wll be put in checkedItemFull state object for sending data to parent 
                        let arrChecked = []
                        for (let e of that.state.checkedItems) {
                            arrChecked.push({
                                //CheckKey prop to select proper key.
                                [that.props.CheckKey]: e[0],
                                value: e[1]
                            })
                        }
                        that.setState({
                            checkedItemFull: arrChecked
                        })
                    })
                })
        }

    }

    paginationHandler = (pageIndex) => {
        
        this.setState({
            pageIndex: pageIndex
        })
    }

    paginationButtons = () => {
        const buttonsData = [];
        let divisionRate = Math.ceil(this.props.data.length / this.props.paginationAmount)

        for(let i = 0; i < divisionRate; i++) {
            buttonsData.push(<button className="btn" disabled={this.checkPaginationDisability('individual', i)} onClick={() => this.paginationHandler(i)}>{i + 1}</button>)
            
        }
        return buttonsData
    }

    checkPaginationDisability = (type, pos) => {
        let divisionRate = Math.ceil(this.props.data.length / this.props.paginationAmount)
        if(type === 'prev') {
            return this.state.pageIndex === 0
        }else if(type === 'next') {
            return this.state.pageIndex === (divisionRate - 1)
        }else if(type === 'individual') {
            return this.state.pageIndex === pos
        }
    }

    render() {
        const table = this;
        const { columns, data, showSlNo, sortType, checkbox } = this.props;
        const props = this.props
        // this.setState({ data: data})


        return (
            <React.Fragment>
                <Table striped responsive>
                    <thead className="text-center">
                        <tr>
                            {
                                checkbox === "true" &&
                                <th style={{ backgroundColor: 'black' }}>
                                    <div className="text-left " style={{ position: 'relative' }}>

                                        <input type="checkbox" id="mainCheckbox" ref={this.mainCheckbox} onChange={(e) => this.handleChange(e, data, 'all')} className="cursor-pointer" />
                                    </div>
                                </th>
                            }
                            {columns.map((column, index) => {
                                return column.sort === true ? <th style={{ backgroundColor: 'black' }} onClick={() => { this.props.sortBy(column.key) }}
                                    className={column.headingAlign === true ? ` text-center  text-white display-hover cursor-pointer ` : ` text-left text-white display-hover cursor-pointer `}
                                    key={index}
                                >{column.name}&nbsp;
                                    {
                                        (sortType === false && column.sort === true && data.length > 1) &&
                                        <i className="fas fa-sort-up custom-sort "></i>
                                    }

                                    {
                                        (sortType === true && column.sort === true && data.length > 1) &&
                                        <i className="fas fa-sort-down custom-sort "></i>
                                    }
                                    {
                                        (column.sort === true && data.length > 1) &&
                                        <i className="fas fa-sort custom-sort-display "></i>
                                    }
                                </th>
                                    :
                                    <th style={{ backgroundColor: 'black' }}
                                        className={column.headingAlign === true ? " text-center  text-white" : " text-left text-white"}
                                        key={index}>
                                        {column.name}
                                    </th>
                            })}
                        </tr>
                    </thead>

                    <tbody className={this.props.alignCenter === true ? 'text-center' : ''}>


                        {data.length > 0 &&
                            // table.props.RowGrouping ? 
                            //     table.props.RowGrouping.groups.map(group => {
                            //         const {groupKey} = table.props.RowGrouping
                            //         let theadGroup;
                                        
                            //         return (
                            //             <React.Fragment>
                            //                 <tr>
                            //                     <th className="text-left" colSpan={checkbox === "true" ? columns.length + 1 : columns.length}>{group.name}</th>
                            //                 </tr>
                            //                 {
                            //                     data.map(function (columnData, i) {
                            //                         if(group.active === columnData[groupKey]) {
                            //                             return (
                            //                                 <React.Fragment>
                            //                                     <tr key={i} style={{ cursor: 'pointer' }}
                            //                                         style={{ backgroundColor: columnData.rowCheck === false ? '#A7A7A7' : '' }}
                            //                                     >
                            //                                         {
                            //                                             columnData.rowCheck === true &&
                            //                                             <td onClick={columnData.rowCheck === true ? () => table.handleChange({
                            //                                                 target: {
                            //                                                     checked: !table.state.checkedItems.get(columnData[table.props.CheckKey]),
                            //                                                     name: columnData[table.props.CheckKey]
                            //                                                 }
                            //                                             }, columnData, 'single') : null}>
                            //                                                 {
                            //                                                     <Checkbox name={columnData[table.props.CheckKey]} checked={table.state.checkedItems.get(columnData[table.props.CheckKey])} onChange={(e) => table.handleChange(e, columnData, 'single')} />
                            //                                                 }
                            //                                             </td>
                            //                                         }
                            //                                         {columns.map(function (column, index) {
                            //                                             return columnData[column.header] ?
                            //                                                 <React.Fragment key={index}>
                            //                                                     <td>---</td>
                            //                                                     <td className="text-center" key={index} className="font-weight-bold ">{columnData[column.headerText]}</td>
                            //                                                 </React.Fragment>
                            
                            //                                                 :
                            //                                                 <td
                            //                                                     key={index}
                            //                                                     className={column.alignCenter === true ? " text-center " : " text-left"}
                            //                                                 >
                            
                            //                                                     {
                            //                                                         (column.type !== 'icon') && (column.type !== 'iconButton') &&
                            //                                                         <span style={{ paddingLeft: `${columnData[column.level] * 2}rem` }}>
                            
                            //                                                             {
                            //                                                                 column.level &&
                            //                                                                 columnData[column.level] !== 0 &&
                            //                                                                 <span>
                            //                                                                     --&nbsp;
                            //                                                             </span>
                            //                                                             }
                            //                                                             {
                            //                                                                 column.link !== '' ?
                            //                                                                     <Link
                            //                                                                         className=" text-underline"
                            //                                                                         to={{
                            //                                                                             pathname: column.link + columnData.id,
                            //                                                                             state: { columnData: columnData, index: i },
                            //                                                                             linkId: columnData.id
                            //                                                                         }}
                            //                                                                     >
                            //                                                                         {columnData[column.key]}
                            //                                                                     </Link>
                            //                                                                     :
                            //                                                                     <React.Fragment>
                            
                            //                                                                         {column.color ? <span style={{ color: columnData[column.color] }}> {columnData[column.key]}</span>
                            //                                                                             :
                            //                                                                             columnData[column.key] === null ? '-' : columnData[column.key]}
                            
                            //                                                                     </React.Fragment>
                            //                                                             }
                            //                                                         </span>
                            //                                                     }
                            //                                                     {
                            //                                                         column.key === 'EDIT' &&
                            //                                                         (column.type === 'icon' ?
                            //                                                             <i className={columnData[column.content] + "  cursor-pointer"}></i>
                            //                                                             :
                            //                                                             column.type === 'iconButton' ? <button title={column.title ? column.title : ''} disabled={columnData[column.buttonDisabled]} style={{ backgroundColor: 'rgb(64, 76, 88)' }} className="btn btn-sm" onClick={() => props.onClickEditIcon(columnData)}><i className={column.content + " fa-2x text-white cursor-pointer px-2"}></i></button>
                            //                                                                 :
                            //                                                                 column.type === 'Button' ? <button title={column.title ? column.title : ''} disabled={columnData[column.buttonDisabled]} style={{ backgroundColor: 'rgb(64, 76, 88)' }} className="btn btn-sm text-white" onClick={() => props.onClickEditButton(columnData)}>{column.content}</button>
                            //                                                                     :
                            //                                                                     '')
                            //                                                     }
                            //                                                     {
                            //                                                         column.key === 'DELETE' &&
                            //                                                         (column.type === 'icon' ?
                            //                                                             <i className={columnData[column.content] + "  cursor-pointer"}></i>
                            //                                                             :
                            //                                                             column.type === 'iconButton' ? <button title={column.title ? column.title : ''} disabled={columnData[column.buttonDisabled]} style={{ backgroundColor: 'rgb(64, 76, 88)' }} className="btn btn-sm" onClick={() => props.onClickDelIcon(columnData)}><i className={column.content + " fa-2x text-white cursor-pointer px-2"}></i></button>
                            //                                                                 :
                            //                                                                 column.type === 'Button' ? <button title={column.title ? column.title : ''} disabled={columnData[column.buttonDisabled]} style={{ backgroundColor: 'rgb(64, 76, 88)' }} className="btn btn-sm text-white" onClick={() => props.onClickDelButton(columnData)}>{column.content}</button>
                            //                                                                     :
                            //                                                                     '')
                            //                                                     }
                            
                            //                                                     {
                            //                                                         column.key === 'REMOVE/DELETE' &&
                            //                                                         (column.type === 'icon' ?
                            //                                                             <i onClick={() => table.props.onClickRemoveorDeleteIcon(columnData)
                            //                                                             } className={column.content + " text-danger cursor-pointer"}>
                            //                                                             </i>
                            //                                                             :
                            //                                                             column.type === 'iconButton' ? <button title={column.title ? column.title : ''} disabled={columnData[column.buttonDisabled]} style={{ backgroundColor: 'rgb(64, 76, 88)' }} className="btn btn-sm " onClick={() => props.onClickRemoveorDeleteButton(columnData)}><i className={column.content + " fa-2x text-white cursor-pointer px-2"}></i></button>
                            //                                                                 :
                            //                                                                 column.type === 'Button' ? <button title={column.title ? column.title : ''} disabled={columnData[column.buttonDisabled]} style={{ backgroundColor: 'rgb(64, 76, 88)' }} className="btn btn-sm text-white " onClick={() => props.onClickRemoveorDeleteButton(columnData)}>{column.content}</button>
                            //                                                                     :
                            //                                                                     '')
                            //                                                     }
                            
                            //                                                     {
                            //                                                         column.key === 'DETAILS' &&
                            //                                                         (column.type === 'icon' ?
                            //                                                             <i onClick={() => table.props.onClickDetailsIcon(columnData)
                            //                                                             } className={column.content + " text-danger cursor-pointer"}>
                            //                                                             </i>
                            //                                                             :
                            //                                                             column.type === 'iconButton' ? <button title={column.title ? column.title : ''} disabled={columnData[column.buttonDisabled]} style={{ backgroundColor: 'rgb(64, 76, 88)' }} className="btn btn-sm" onClick={() => props.onClickDetailsButton(columnData)}><i className={column.content + " fa-2x text-white cursor-pointer px-2"}></i></button>
                            //                                                                 :
                            //                                                                 column.type === 'Button' ? <button title={column.title ? column.title : ''} disabled={columnData[column.buttonDisabled]} style={{ backgroundColor: 'rgb(64, 76, 88)' }} className="btn btn-sm text-white " onClick={() => props.onClickDetailsButton(columnData)}>{column.content}</button>
                            //                                                                     :
                            //                                                                     '')
                            //                                                     }
                            
                            
                            
                            //                                                 </td>;
                            //                                         })}
                            //                                     </tr>
                            //                                 </React.Fragment>
                            //                             )
                            //                         }
                            //                     })
                            //                 }
                            //             </React.Fragment>
                            //         )
                            //     })
                            // :
                            this.props.pagination ?
                                data.filter(
                                    (_, i) => {
                                        return i >= (this.state.pageIndex * this.props.paginationAmount) && i < (this.state.pageIndex + 1) * this.props.paginationAmount
                                    }
                                ).map((columnData, i) => {
                                    return (
                                        <React.Fragment>
                                            <tr key={i} style={{ cursor: 'pointer' }}
                                                style={{ backgroundColor: columnData.rowCheck === false ? '#A7A7A7' : '' }}
                                            >
                                                {
                                                    columnData.rowCheck === true &&
                                                    <td onClick={columnData.rowCheck === true ? () => table.handleChange({
                                                        target: {
                                                            checked: !table.state.checkedItems.get(columnData[table.props.CheckKey]),
                                                            name: columnData[table.props.CheckKey]
                                                        }
                                                    }, columnData, 'single') : null}>
                                                        {
                                                            <Checkbox name={columnData[table.props.CheckKey]} checked={table.state.checkedItems.get(columnData[table.props.CheckKey])} onChange={(e) => table.handleChange(e, columnData, 'single')} />
                                                        }
                                                    </td>
                                                }
                                                {columns.map(function (column, index) {
                                                    return columnData[column.header] ?
                                                        <React.Fragment key={index}>
                                                            <td>---</td>
                                                            <td className="text-center" key={index} className="font-weight-bold ">{columnData[column.headerText]}</td>
                                                        </React.Fragment>
        
                                                        :
                                                        <td
                                                            key={index}
                                                            className={column.alignCenter === true ? " text-center " : " text-left"}
                                                        >
        
                                                            {
                                                                (column.type !== 'icon') && (column.type !== 'iconButton') &&
                                                                <span style={{ paddingLeft: `${columnData[column.level] * 2}rem` }}>
        
                                                                    {
                                                                        column.level &&
                                                                        columnData[column.level] !== 0 &&
                                                                        <span>
                                                                            --&nbsp;
                                                                    </span>
                                                                    }
                                                                    {
                                                                        column.link !== '' ?
                                                                            <Link
                                                                                className=" text-underline"
                                                                                to={{
                                                                                    pathname: column.link + columnData.id,
                                                                                    state: { columnData: columnData, index: i },
                                                                                    linkId: columnData.id
                                                                                }}
                                                                            >
                                                                                {columnData[column.key]}
                                                                            </Link>
                                                                            :
                                                                            <React.Fragment>
        
                                                                                {column.color ? <span style={{ color: columnData[column.color] }}> {columnData[column.key]}</span>
                                                                                    :
                                                                                    columnData[column.key] === null ? '-' : columnData[column.key]}
        
                                                                            </React.Fragment>
                                                                    }
                                                                </span>
                                                            }
                                                            {
                                                                column.key === 'EDIT' &&
                                                                (column.type === 'icon' ?
                                                                    <i className={columnData[column.content] + "  cursor-pointer"}></i>
                                                                    :
                                                                    column.type === 'iconButton' ? <button title={column.title ? column.title : ''} disabled={columnData[column.buttonDisabled]} style={{ backgroundColor: 'rgb(64, 76, 88)' }} className="btn btn-sm" onClick={() => props.onClickEditIcon(columnData)}><i className={column.content + " fa-2x text-white cursor-pointer px-2"}></i></button>
                                                                        :
                                                                        column.type === 'Button' ? <button title={column.title ? column.title : ''} disabled={columnData[column.buttonDisabled]} style={{ backgroundColor: 'rgb(64, 76, 88)' }} className="btn btn-sm text-white" onClick={() => props.onClickEditButton(columnData)}>{column.content}</button>
                                                                            :
                                                                            '')
                                                            }
                                                            {
                                                                column.key === 'DELETE' &&
                                                                (column.type === 'icon' ?
                                                                    <i className={columnData[column.content] + "  cursor-pointer"}></i>
                                                                    :
                                                                    column.type === 'iconButton' ? <button title={column.title ? column.title : ''} disabled={columnData[column.buttonDisabled]} style={{ backgroundColor: 'rgb(64, 76, 88)' }} className="btn btn-sm" onClick={() => props.onClickDelIcon(columnData)}><i className={column.content + " fa-2x text-white cursor-pointer px-2"}></i></button>
                                                                        :
                                                                        column.type === 'Button' ? <button title={column.title ? column.title : ''} disabled={columnData[column.buttonDisabled]} style={{ backgroundColor: 'rgb(64, 76, 88)' }} className="btn btn-sm text-white" onClick={() => props.onClickDelButton(columnData)}>{column.content}</button>
                                                                            :
                                                                            '')
                                                            }
        
                                                            {
                                                                column.key === 'REMOVE/DELETE' &&
                                                                (column.type === 'icon' ?
                                                                    <i onClick={() => table.props.onClickRemoveorDeleteIcon(columnData)
                                                                    } className={column.content + " text-danger cursor-pointer"}>
                                                                    </i>
                                                                    :
                                                                    column.type === 'iconButton' ? <button title={column.title ? column.title : ''} disabled={columnData[column.buttonDisabled]} style={{ backgroundColor: 'rgb(64, 76, 88)' }} className="btn btn-sm " onClick={() => props.onClickRemoveorDeleteButton(columnData)}><i className={column.content + " fa-2x text-white cursor-pointer px-2"}></i></button>
                                                                        :
                                                                        column.type === 'Button' ? <button title={column.title ? column.title : ''} disabled={columnData[column.buttonDisabled]} style={{ backgroundColor: 'rgb(64, 76, 88)' }} className="btn btn-sm text-white " onClick={() => props.onClickRemoveorDeleteButton(columnData)}>{column.content}</button>
                                                                            :
                                                                            '')
                                                            }
        
                                                            {
                                                                column.key === 'DETAILS' &&
                                                                (column.type === 'icon' ?
                                                                    <i onClick={() => table.props.onClickDetailsIcon(columnData)
                                                                    } className={column.content + " text-danger cursor-pointer"}>
                                                                    </i>
                                                                    :
                                                                    column.type === 'iconButton' ? <button title={column.title ? column.title : ''} disabled={columnData[column.buttonDisabled]} style={{ backgroundColor: 'rgb(64, 76, 88)' }} className="btn btn-sm" onClick={() => props.onClickDetailsButton(columnData)}><i className={column.content + " fa-2x text-white cursor-pointer px-2"}></i></button>
                                                                        :
                                                                        column.type === 'Button' ? <button title={column.title ? column.title : ''} disabled={columnData[column.buttonDisabled]} style={{ backgroundColor: 'rgb(64, 76, 88)' }} className="btn btn-sm text-white " onClick={() => props.onClickDetailsButton(columnData)}>{column.content}</button>
                                                                            :
                                                                            '')
                                                            }
        
        
        
                                                        </td>;
                                                })}
                                            </tr>
                                        </React.Fragment>
                                    )
                                })
                            :
                            data.map(function (columnData, i) {
                                
                                return (
                                    <React.Fragment>
                                        <tr key={i} style={{ cursor: 'pointer' }}
                                            style={{ backgroundColor: columnData.rowCheck === false ? '#A7A7A7' : '' }}
                                        >
                                            {
                                                columnData.rowCheck === true &&
                                                <td onClick={columnData.rowCheck === true ? () => table.handleChange({
                                                    target: {
                                                        checked: !table.state.checkedItems.get(columnData[table.props.CheckKey]),
                                                        name: columnData[table.props.CheckKey]
                                                    }
                                                }, columnData, 'single') : null}>
                                                    {
                                                        <Checkbox name={columnData[table.props.CheckKey]} checked={table.state.checkedItems.get(columnData[table.props.CheckKey])} onChange={(e) => table.handleChange(e, columnData, 'single')} />
                                                    }
                                                </td>
                                            }
                                            {columns.map(function (column, index) {
                                                return columnData[column.header] ?
                                                    <React.Fragment key={index}>
                                                        <td>---</td>
                                                        <td className="text-center" key={index} className="font-weight-bold ">{columnData[column.headerText]}</td>
                                                    </React.Fragment>

                                                    :
                                                    <td
                                                        key={index}
                                                        className={column.alignCenter === true ? " text-center " : " text-left"}
                                                    >

                                                        {
                                                            (column.type !== 'icon') && (column.type !== 'iconButton') &&
                                                            <span style={{ paddingLeft: `${columnData[column.level] * 2}rem` }}>

                                                                {
                                                                    column.level &&
                                                                    columnData[column.level] !== 0 &&
                                                                    <span>
                                                                        --&nbsp;
                                                                </span>
                                                                }
                                                                {
                                                                    column.link !== '' ?
                                                                        <Link
                                                                            className=" text-underline"
                                                                            to={{
                                                                                pathname: column.link + columnData.id,
                                                                                state: { columnData: columnData, index: i },
                                                                                linkId: columnData.id
                                                                            }}
                                                                        >
                                                                            {columnData[column.key]}
                                                                        </Link>
                                                                        :
                                                                        <React.Fragment>

                                                                            {column.color ? <span style={{ color: columnData[column.color] }}> {columnData[column.key]}</span>
                                                                                :
                                                                                columnData[column.key] === null ? '-' : columnData[column.key]}

                                                                        </React.Fragment>
                                                                }
                                                            </span>
                                                        }
                                                        {
                                                            column.key === 'EDIT' &&
                                                            (column.type === 'icon' ?
                                                                <i className={columnData[column.content] + "  cursor-pointer"}></i>
                                                                :
                                                                column.type === 'iconButton' ? <button title={column.title ? column.title : ''} disabled={columnData[column.buttonDisabled]} style={{ backgroundColor: 'rgb(64, 76, 88)' }} className="btn btn-sm" onClick={() => props.onClickEditIcon(columnData)}><i className={column.content + " fa-2x text-white cursor-pointer px-2"}></i></button>
                                                                    :
                                                                    column.type === 'Button' ? <button title={column.title ? column.title : ''} disabled={columnData[column.buttonDisabled]} style={{ backgroundColor: 'rgb(64, 76, 88)' }} className="btn btn-sm text-white" onClick={() => props.onClickEditButton(columnData)}>{column.content}</button>
                                                                        :
                                                                        '')
                                                        }
                                                        {
                                                            column.key === 'DELETE' &&
                                                            (column.type === 'icon' ?
                                                                <i className={columnData[column.content] + "  cursor-pointer"}></i>
                                                                :
                                                                column.type === 'iconButton' ? <button title={column.title ? column.title : ''} disabled={columnData[column.buttonDisabled]} style={{ backgroundColor: 'rgb(64, 76, 88)' }} className="btn btn-sm" onClick={() => props.onClickDelIcon(columnData)}><i className={column.content + " fa-2x text-white cursor-pointer px-2"}></i></button>
                                                                    :
                                                                    column.type === 'Button' ? <button title={column.title ? column.title : ''} disabled={columnData[column.buttonDisabled]} style={{ backgroundColor: 'rgb(64, 76, 88)' }} className="btn btn-sm text-white" onClick={() => props.onClickDelButton(columnData)}>{column.content}</button>
                                                                        :
                                                                        '')
                                                        }

                                                        {
                                                            column.key === 'REMOVE/DELETE' &&
                                                            (column.type === 'icon' ?
                                                                <i onClick={() => table.props.onClickRemoveorDeleteIcon(columnData)
                                                                } className={column.content + " text-danger cursor-pointer"}>
                                                                </i>
                                                                :
                                                                column.type === 'iconButton' ? <button title={column.title ? column.title : ''} disabled={columnData[column.buttonDisabled]} style={{ backgroundColor: 'rgb(64, 76, 88)' }} className="btn btn-sm " onClick={() => props.onClickRemoveorDeleteButton(columnData)}><i className={column.content + " fa-2x text-white cursor-pointer px-2"}></i></button>
                                                                    :
                                                                    column.type === 'Button' ? <button title={column.title ? column.title : ''} disabled={columnData[column.buttonDisabled]} style={{ backgroundColor: 'rgb(64, 76, 88)' }} className="btn btn-sm text-white " onClick={() => props.onClickRemoveorDeleteButton(columnData)}>{column.content}</button>
                                                                        :
                                                                        '')
                                                        }

                                                        {
                                                            column.key === 'DETAILS' &&
                                                            (column.type === 'icon' ?
                                                                <i onClick={() => table.props.onClickDetailsIcon(columnData)
                                                                } className={column.content + " text-danger cursor-pointer"}>
                                                                </i>
                                                                :
                                                                column.type === 'iconButton' ? <button title={column.title ? column.title : ''} disabled={columnData[column.buttonDisabled]} style={{ backgroundColor: 'rgb(64, 76, 88)' }} className="btn btn-sm" onClick={() => props.onClickDetailsButton(columnData)}><i className={column.content + " fa-2x text-white cursor-pointer px-2"}></i></button>
                                                                    :
                                                                    column.type === 'Button' ? <button title={column.title ? column.title : ''} disabled={columnData[column.buttonDisabled]} style={{ backgroundColor: 'rgb(64, 76, 88)' }} className="btn btn-sm text-white " onClick={() => props.onClickDetailsButton(columnData)}>{column.content}</button>
                                                                        :
                                                                        '')
                                                        }



                                                    </td>;
                                            })}
                                        </tr>
                                    </React.Fragment>
                                )
                            })}
                        {
                            data.length == 0 &&
                            <tr>
                                <td colSpan="10" className="text-center">No data to display</td>
                            </tr>
                        }
                        
                    </tbody>
                </Table>
                {
                    data.length !== 0 && this.props.pagination === true && data.length > this.props.paginationAmount &&
                    <div>
                        {/* <div colSpan={checkbox === "true" ? columns.length -1 : columns.length - 2}></td> */}
                        <div style={{float: 'right'}}>
                            <button className="btn" disabled={this.checkPaginationDisability('prev')} onClick={() => this.paginationHandler(this.state.pageIndex - 1)}>Prev</button>
                                {
                                    this.paginationButtons()
                                }
                            <button className="btn" disabled={this.checkPaginationDisability('next')} onClick={() => this.paginationHandler(this.state.pageIndex + 1)}>Next</button>
                        </div>
                    </div>
                }
            </React.Fragment>
        );
    }
}


export default withRouter(TableNew);


// WEBPACK FOOTER //
// ./src/_components/common/Table/index.jsx